import { Injectable } from '@angular/core';
import { notificationError } from '@components/layout/error/error.utils';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationService } from '@service/notification.service';
import { catchError, map, mergeMap, of } from 'rxjs';
import {
  loadNotificationListEmailSms,
  loadNotificationListEmailSmsFailure,
  loadNotificationListEmailSmsSuccess,
} from './notification-list-email-sms.action';

@Injectable()
export class NotificationListEmailSmsEffect {
  constructor(
    private actions$: Actions,
    private notificationService: NotificationService
  ) {}

  loadNotificationList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNotificationListEmailSms),
      mergeMap(({ currentPageNumber, filters, pageSize }) =>
        this.notificationService
          .getNotificationListEmailSms(currentPageNumber, filters, pageSize)
          .pipe(
            map((body) => loadNotificationListEmailSmsSuccess({ notificationList: body })),
            catchError((error) =>
              of(loadNotificationListEmailSmsFailure({ error: notificationError(error) }))
            )
          )
      )
    )
  );

}
